export type PortalVariant = "school" | "admin";

export type ActorRole = "INTERSTUD_ADMIN" | "SCHOOL_ADMIN" | "ADVISOR";

export interface PortalBranding {
  variant: PortalVariant;
  title: string;
  description: string;
  unauthorizedMessage: string;
  accessDeniedMessage: string;
  metadataTitle: string;
}

export function isSchoolHost(host: string | null | undefined): boolean {
  if (!host) return false;
  return host.toLowerCase().startsWith("pro.");
}

export function isAdminHost(host: string | null | undefined): boolean {
  if (!host) return false;
  return host.toLowerCase().startsWith("admin.");
}

export function getPortalBranding(
  host: string | null | undefined,
): PortalBranding {
  if (isSchoolHost(host)) {
    return {
      variant: "school",
      title: "Interstud Pro",
      description: "Connectez-vous à votre espace école",
      unauthorizedMessage:
        "Accès non autorisé. Connectez-vous avec votre compte établissement.",
      accessDeniedMessage:
        "Ce compte n'a pas accès au portail école. Connectez-vous avec un compte établissement.",
      metadataTitle: "Interstud Pro",
    };
  }

  return {
    variant: "admin",
    title: "Interstud Admin",
    description: "Connectez-vous avec votre compte administrateur",
    unauthorizedMessage:
      "Accès non autorisé. Connectez-vous avec un compte administrateur.",
    accessDeniedMessage:
      "Ce compte n'a pas accès au portail administrateur Interstud.",
    metadataTitle: "Interstud Admin",
  };
}

export function getAllowedActorRolesForHost(
  host: string | null | undefined,
): ActorRole[] | null {
  if (isSchoolHost(host)) return ["SCHOOL_ADMIN", "ADVISOR"];
  if (isAdminHost(host)) return ["INTERSTUD_ADMIN"];
  return null;
}

export function isPortalAccessAllowed(
  host: string | null | undefined,
  role: string | null | undefined,
): boolean {
  const allowed = getAllowedActorRolesForHost(host);
  if (!allowed) return true;
  if (!role) return false;
  return (allowed as string[]).includes(role);
}
